import LazyLoad from "vanilla-lazyload";

export const lazyLoad = (function ($) {

    function init() {
        return new LazyLoad({
            elements_selector: ".lazy",
            class_loading: ".lazy-loading" // avoid conflict with other .loading class
        });
    }

    return {
        init: init
    }

})(jQuery);
